var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-reply"},[_c('div',{staticClass:"ed-re-msg"},[_c('div',{staticClass:"msg-reply-fio"},[_vm._v(_vm._s(_vm.msg.is_anon ? 'Анонимный пользователь' : _vm.msg.fullname))]),_c('div',[_vm._v(_vm._s(_vm.msg.text))])]),_c('div',{staticClass:"reply-msg-close",on:{"click":_vm.onClick}},[_c('Close')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }